var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-loading"},[_c('h2',[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(" Cargando...")])])}]

export { render, staticRenderFns }